import { createContext } from "react";

export enum MultiSelectMode {
	FinanceReport = "finance_report",
	MoveProcess = "move_process",
}

export interface MultiSelectButtonState {
	isOpen?: boolean;
	isCreating?: boolean;
	mode?: MultiSelectMode;
	selectedFiles?: string[];
}

export const initialState: MultiSelectButtonState = {
	isOpen: false,
	isCreating: false,
	mode: undefined,
	selectedFiles: [],
};

export interface MultiSelectButtonContext extends MultiSelectButtonState {
	handleMultiSelectButtonClose: () => void;
	handleMultiSelectButtonOpen: (mode: MultiSelectMode) => void;
	handleMultiSelectButtonOnCreate: () => void;
	handleSelectFile: (selectedFile: string) => void;
	handleSetAllSelectedFile: (selectedFileIds: string[]) => void;
}

export const MultiSelectButtonContext = createContext<MultiSelectButtonContext>(
	{
		...initialState,
		handleMultiSelectButtonClose: function (): void {
			throw new Error("Function not implemented.");
		},
		handleMultiSelectButtonOpen: function (_mode: MultiSelectMode): void {
			throw new Error("Function not implemented.");
		},
		handleMultiSelectButtonOnCreate: function (): void {
			throw new Error("Function not implemented.");
		},
		handleSelectFile: function (_selectedFile: string): void {
			throw new Error("Function not implemented.");
		},
		handleSetAllSelectedFile: function (_selectedFileIds: string[]): void {
			throw new Error("Function not implemented.");
		},
	},
);
